@let serviceCenters = (serviceCenters$ | async) ?? [];
@let isLoading = serviceCentersLoadingStatus() === LoadingState.LOADING;
@let isLoaded = serviceCentersLoadingStatus() === LoadingState.READY;

<section class="service-centers page-viewport">
  <mon-page-toolbar
    titleTranslateKey="monitoring.menu.service-centers"
    [searchControl]="searchControl"
    searchPlaceholderTranslateKey="monitoring.search"
    [showFiltersButton]="false"
    [actions]="toolbarActions"
    (actionClick)="onToolbarAction($event)"
  />

  <section class="page-content page-table page-table-scroll">
    <div class="page-table-scroll__content">
      <lib-table
        class="page-table-scroll__table service-centers__table"
        [columns]="columns"
        [dataSource]="serviceCenters"
        [cellTemplates]="{
          name: nameTpl,
          address: addressTpl,
          contactInfo: contactInfoTpl,
          actions: actionsTpl,
        }"
        [loaded]="isLoaded"
        [loading]="isLoading"
      />
    </div>

    @if (!(serviceCenters.length === 0 && currentPage() === 1)) {
      <lib-pagination
        [totalCount]="totalCount()"
        [loading]="isLoading"
        [pageIndex]="currentPage()"
        [pageSize]="100"
        (paginationChange)="onPageChange($event)"
      />
    }
  </section>

  <ng-template
    #nameTpl
    let-row="data"
  >
    <div class="service-centers__cell">{{ asServiceCenter(row).name || '—' }}</div>
  </ng-template>

  <ng-template
    #addressTpl
    let-row="data"
  >
    <div class="service-centers__cell">{{ asServiceCenter(row).address || '—' }}</div>
  </ng-template>

  <ng-template
    #contactInfoTpl
    let-row="data"
  >
    <div class="service-centers__cell">{{ asServiceCenter(row).contactInfo || '—' }}</div>
  </ng-template>

  <ng-template
    #actionsTpl
    let-row="data"
  >
    @let serviceCenter = asServiceCenter(row);
    @if (canManageMaintenance()) {
      <div class="service-centers__actions">
        <lib-icon-button
          icon="pen"
          [title]="'monitoring.service-centers.actions.edit' | translate"
          (click)="openServiceCenterModal(ServiceCenterModalAction.Edit, serviceCenter)"
        />
        <lib-icon-button
          icon="trash"
          [title]="'monitoring.service-centers.actions.delete' | translate"
          (click)="confirmDelete(serviceCenter)"
        />
      </div>
    }
  </ng-template>
</section>
